<template>
  <div class="new-booking-page">
    <!-- FRONT NAVIGATION -->
    <front-navigation></front-navigation>

    <div class="app-container">
      
      <!-- HEADER & TOP CART -->
      <div class="header-row">
        <div class="header-text">
          <h2 class="earthwerk-font">Activities</h2>
          <p class="subtitle">Optional add-ons</p>
        </div>
        
        <!-- CART BUTTON (Top Right) -->
        <div class="cart-btn" @click="openCartSidebar">
          <v-icon color="white" size="24">mdi-cart</v-icon>
          <span class="cart-badge" v-if="cartCount > 0">{{ cartCount }}</span>
        </div>
      </div>

      <!-- SECTION CARD WRAPPER (Overrides child component on mobile) -->
      <div class="section-card mobile-component-wrapper">
        <!-- YOUR EXISTING ACTIVITIES COMPONENT -->
        <activities />
      </div>

    </div>

    <!-- FLOATING CTA -->
    <button class="floating-cta" @click="continueToAccommodation">
      <v-icon small color="#ffffff">mdi-arrow-right</v-icon>
      <span>Continue</span>
    </button>

    <!-- SIDEBAR -->
    <transition name="fade">
      <div class="sidebar-overlay" v-if="sidebarOpen" @click="closeSidebar"></div>
    </transition>

    <transition name="slide">
      <div class="sidebar-wrapper" v-show="sidebarOpen">
        <div class="sidebar-header">
          <h3 class="sidebar-title">
            <v-icon small class="mr-1">mdi-cart</v-icon>
            Your Booking Cart
            <span v-if="cartCount > 0" class="sidebar-badge">{{ cartCount }}</span>
          </h3>
          <v-btn icon small @click="closeSidebar" class="close-sidebar-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <side-bar ref="sidebar" @close="closeSidebar"></side-bar>
      </div>
    </transition>

  </div>
</template>

<script>
import FrontNavigation from '../Repeated/FrontNavigation'
import SideBar from '../Repeated/SideBar.vue'
import Activities from '../Repeated/Activities.vue'

export default {
  name: 'ActivitiesPage',
  components: { FrontNavigation, SideBar, Activities },
  data() {
    return {
      sidebarOpen: false,
      cartCount: 0
    }
  },
  mounted() {
    this.updateCartCount();
    this.$root.$on('cart-updated', this.updateCartCount);
  },
  beforeDestroy() {
    this.$root.$off('cart-updated', this.updateCartCount);
  },
  methods: {
    updateCartCount() {
      let count = 0;
      try {
        const guestsData = JSON.parse(localStorage.getItem('guests') || '{"adults":0,"children":0}');
        const totalGuests = (guestsData.adults || 0) + (guestsData.children || 0);
        if (totalGuests > 0) count++;
      } catch (e) {}

      try {
        const vehicleData = JSON.parse(localStorage.getItem('vehicle_data') || '[]');
        const hasVehicles = vehicleData.some(v => Number(v.vehicles) > 0);
        const vehicleSep = JSON.parse(localStorage.getItem('vehicle_separate') || 'false');
        if (hasVehicles || vehicleSep) count++;
      } catch (e) {}

      try {
        const activities = JSON.parse(localStorage.getItem('activity_data') || '[]');
        if (activities.length > 0) count++;
      } catch (e) {}

      try {
        const facilities = JSON.parse(localStorage.getItem('facility_data') || '[]');
        if (facilities.length > 0) count++;
      } catch (e) {}

      this.cartCount = count;
    },
    openCartSidebar() {
      this.sidebarOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeSidebar() {
      this.sidebarOpen = false;
      document.body.style.overflow = '';
    },
    continueToAccommodation() {
      window.scrollTo(0, 0);
      this.$router.push('/accommodation'); 
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'Earthwerk';
  src: url('PizzaDude.dk-Earthwerk.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

/* CLEARED BACKGROUND */
.new-booking-page {
  background: transparent; 
  min-height: 100vh;
  padding: 24px 16px 120px; /* Extra padding so content doesn't hide behind floating button */
  position: relative;
}

.app-container {
  max-width: 1000px;
  margin: 0 auto;
}

/* HEADER & TOP CART */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  margin-top: 10px;
}

.header-text h2 {
  color: #2d4a1e;
  font-size: 28px;
  margin: 0 0 4px 0;
  text-shadow: 0 1px 3px rgba(255,255,255,0.5);
}

.subtitle {
  color: #5e6e4e;
  font-size: 14px;
  margin: 0;
}

/* Cart Button at Top Right */
.cart-btn {
  position: relative;
  width: 50px;
  height: 50px;
  background: #74a533;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(116, 165, 51, 0.3);
  cursor: pointer;
  transition: transform 0.2s;
  flex-shrink: 0;
}

.cart-btn:hover {
  transform: scale(1.05);
}

.cart-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ff5252;
  color: white;
  font-size: 12px;
  font-weight: bold;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
}

.earthwerk-font {
  font-family: 'Earthwerk', sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Cards */
.section-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

/* FLOATING CTA (Exact same as Index) */
.floating-cta {
  position: fixed;
  right: 18px;
  bottom: calc(18px + env(safe-area-inset-bottom));
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  background: #74a533;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  padding: 14px 22px;
  border-radius: 40px;
  box-shadow: 0 10px 26px -6px rgba(116, 165, 51, 0.55),
              0 4px 12px -4px rgba(0, 0, 0, 0.2);
  z-index: 55;
  transition: transform 0.12s, box-shadow 0.12s;
}
.floating-cta:hover {
  box-shadow: 0 14px 30px -6px rgba(116, 165, 51, 0.7),
              0 6px 16px -4px rgba(0, 0, 0, 0.25);
}
.floating-cta:active {
  transform: scale(0.96);
}

/* SIDEBAR ANIMATIONS & LAYOUT */
.sidebar-overlay {
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  background: rgba(15, 23, 33, 0.55);
  z-index: 999;
  backdrop-filter: blur(1px);
}

.fade-enter-active,
.fade-leave-active { transition: opacity 0.25s ease; }
.fade-enter,
.fade-leave-to { opacity: 0; }

.sidebar-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  width: 380px;
  max-width: 92vw;
  height: 100vh;
  background: #fff;
  box-shadow: -6px 0 28px rgba(0, 0, 0, 0.14);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.slide-enter-active,
.slide-leave-active { transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
.slide-enter,
.slide-leave-to { transform: translateX(100%); }

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #74a533;
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
}

.sidebar-title {
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sidebar-badge {
  background: #ff5252;
  color: #fff;
  border-radius: 999px;
  min-width: 22px;
  height: 22px;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  margin-left: 8px;
}

.close-sidebar-btn {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.18) !important;
  border-radius: 50% !important;
}

/* ==================================================== */
/* MOBILE OVERRIDES FOR CHILD ACTIVITIES COMPONENT      */
/* ==================================================== */
@media (max-width: 960px) {
  .mobile-component-wrapper {
    padding: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .mobile-component-wrapper :deep(.activities-container) {
    max-width: 100%;
    margin: 0;
  }

  .mobile-component-wrapper :deep(.v-layout) {
    display: flex;
    flex-direction: column;
  }

  .mobile-component-wrapper :deep(.v-flex) {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100% !important;
    padding: 0 !important;
  }

  .mobile-component-wrapper :deep(.v-container) {
    padding: 0 0 16px 0 !important;
  }

  .mobile-component-wrapper :deep(.activity-card) {
    border-radius: 16px !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important;
    background: #fff !important;
    overflow: hidden;
    margin-bottom: 0;
    border: none !important;
  }

  .mobile-component-wrapper :deep(.activity-image) {
    border-radius: 0 !important;
    height: 200px !important;
  }

  .mobile-component-wrapper :deep(.activity-badge) {
    font-size: 12px !important;
    padding: 6px 12px !important;
    border-radius: 16px !important;
    background: rgba(116, 165, 51, 0.92) !important;
    white-space: normal !important;
    line-height: 1.3;
  }

  .mobile-component-wrapper :deep(.v-card__text),
  .mobile-component-wrapper :deep(.v-card > .v-container) {
    padding: 16px !important;
  }

  .mobile-component-wrapper :deep(.activity-title) {
    font-size: 16px !important;
    font-weight: 700 !important;
    margin-bottom: 8px !important;
    line-height: 1.3;
  }

  .mobile-component-wrapper :deep(.capacity-display) {
    margin-bottom: 12px;
  }
  
  .mobile-component-wrapper :deep(.capacity-label),
  .mobile-component-wrapper :deep(.capacity-value) {
    font-size: 13px !important;
  }

  .mobile-component-wrapper :deep(.book-now-btn) {
    width: 100% !important;
    border-radius: 40px !important;
    margin-top: 8px !important;
    padding: 12px !important;
    font-size: 14px !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 10px rgba(116, 165, 51, 0.25);
  }

  .mobile-component-wrapper :deep(.info-icon) {
    margin-bottom: 8px;
    display: block;
  }
}

@media (max-width: 600px) {
  .new-booking-page { padding: 16px 12px 100px; }
  .header-text h2 { font-size: 22px; }

  .floating-cta {
    right: 14px;
    bottom: calc(14px + env(safe-area-inset-bottom));
    padding: 12px 18px;
    font-size: 13px;
  }

  .sidebar-wrapper {
    width: 100%;
    max-width: 100%;
    height: 85vh;
    top: auto;
    bottom: 0;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .slide-enter, .slide-leave-to { transform: translateY(100%); }
}
</style>